// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"7a3e316e","178":"2287bef3","238":"4efe55db","240":"5d7f4f19","260":"2b64079e","293":"f41358a6","318":"aff81468","326":"516c139a","406":"21fe4a51","453":"4ef5542d","459":"dc61db47","606":"8bbd5a88","641":"3d05e358","855":"e10d4233"}[chunkId] + ".chunk.js";
};